import React from 'react';
import { range } from 'lodash';
import { GridItem, WithInfoIcon, Checkbox, Typography, TextField, MenuItem } from 'seagull';
import styles from "./ExpirationDate.module.scss";
const ExpirationDate = _ref => {
  let {
    daysToExpiration,
    hasExpirationDate,
    disabled,
    setDaysToExpiration,
    setHasExpirationDate
  } = _ref;
  return /*#__PURE__*/React.createElement(GridItem, {
    span: 12,
    "data-testid": "expiration-date"
  }, /*#__PURE__*/React.createElement(WithInfoIcon, {
    info: "Set the number of days after which the proposal will expire. After the expiration date your client will not be able to sign or access the proposal.",
    infoTestId: "expiration-date-tooltip"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: hasExpirationDate,
    disabled: disabled,
    onChange: e => setHasExpirationDate(e.target.checked),
    "data-testid": "expiration-date-checkbox"
  }, /*#__PURE__*/React.createElement(Typography, null, "Set an expiration for this proposal"))), hasExpirationDate && /*#__PURE__*/React.createElement(Typography, {
    className: styles.days
  }, "The proposal expires", /*#__PURE__*/React.createElement(TextField, {
    size: "small",
    width: 70,
    select: true,
    disabled: disabled,
    value: daysToExpiration,
    onChange: e => setDaysToExpiration(+e.target.value),
    "data-testid": "expiration-days-select"
  }, range(1, 91).map(day => /*#__PURE__*/React.createElement(MenuItem, {
    key: day,
    value: day + '',
    "data-testid": "expiration-days-select-item-".concat(day)
  }, day))), "days after sending"));
};
export default ExpirationDate;